import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/allocation/recordList/record/numberInput/styles.scss';export default {
  "numberInput": "_numberInput_1guc2_1",
  "main": "_main_1guc2_10",
  "arrows": "_arrows_1guc2_20",
  "input": "_input_1guc2_24",
  "icon": "_icon_1guc2_55",
  "iconBox": "_iconBox_1guc2_59",
  "disabled": "_disabled_1guc2_80"
};